import React from 'react'
import '../css/gallery.css';

const Gallery = () => {
  return (
    <>
      <div className="gallery-section">
        <div className="about-banner contact-banner">
          <img src="images/banner3.png" alt="" />
        </div>
        <div className="our-gallery">
            <h2>Our Gallery</h2>
            <div className="gallery-images">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRG9mNneL7sMXSihX_87NMU7C-UcgeKSnuuKQ&s" alt="" />
            </div>
        </div>
      </div>
    </>
  )
}

export default Gallery
